export const getLiquidationSettlementLabel = (value) => {
  const amount = Number(value || 0);
  if (amount < 0) return "Return";
  if (amount > 0) return "Reimbursement";
  return "Liquidation";
};

export const getLiquidationSettlementAmount = (value) => Math.abs(Number(value || 0));
